import { EmptyTableResults } from '@/components/Table/styles';
import { TableType } from '@/components/Table/types/types';
import { OPCO_USERS_TABLE_CONFIG } from '../const/opcoUsersTableConfig';
import { OpcoUserType } from '../../types/types';
import { getOpcoUserDetailsPath } from '@/bundle/_Opco/_OpcoUsersPage/OpcoUserDetailsPage/path/path';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice';
import { MobileTable } from '@/components/Table/MobileTable/MobileTable';
import { NoResults } from '@/components/NoResults/NoResults';
import NoUsersIcon from '@/images/NoUsersIcon.svg?react';
import { DesktopTable } from '@/components/Table/DesktopTable';

export const OpcoUsersTable = ({ items = [], isLoading }: TableType<OpcoUserType>) => {
  const { navigateFrom } = useStatefulNavigation();
  const { isMobile } = useResponsiveDevice();

  const hasItems = !!items.length;
  const noItems = !hasItems && !isLoading;

  const navigateToUserDetails = (item: OpcoUserType) => {
    navigateFrom(getOpcoUserDetailsPath(item?.user?.id));
  };

  if (noItems) {
    return (
      <EmptyTableResults>
        <NoResults icon={<NoUsersIcon />} message='Please create your first user.' />
      </EmptyTableResults>
    );
  }

  return (
    <>
      {isMobile ? (
        <MobileTable
          config={OPCO_USERS_TABLE_CONFIG}
          items={items}
          isLoading={isLoading}
          onRowClick={navigateToUserDetails}
        />
      ) : (
        <DesktopTable
          config={OPCO_USERS_TABLE_CONFIG}
          items={items}
          isLoading={isLoading}
          onRowClick={navigateToUserDetails}
        />
      )}
    </>
  );
};
